import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const MinimalLayout = () => (
    <>
        <Outlet />
    </>
);

export default MinimalLayout;
